<template>
    <div class="w-100">
        <div class="worked-time-index-top-wrap flex justify-between align-items-center flex-wrap mb-2">
            <button @click="previousYear" class="btn btn-secondary flex align-items-center mb-2" :enabled="this.selected_year === this.company_create_year" onclick="this.blur()"><i class="fas fa-chevron-left"></i><span class="d-inline-block ml-1 hide-lte-991">Vorige jaar</span></button>
            <h4 class="card-title mb-2">{{ this.selected_year }}</h4>
            <button @click="nextYear" class="btn btn-secondary flex align-items-center mb-2" :disabled="this.current_year === this.selected_year" onclick="this.blur()"><span class="d-inline-block mr-1 hide-lte-991">Volgende jaar</span><i class="fas fa-chevron-right"></i></button>
        </div>
        <div class="position-relative overflow-hidden w-full">
            <div class="table-responsive">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="col-1">Nummer</th>
                            <th style="line-height: 23px;">Referentie</th>
                            <th style="line-height: 23px;">Totaal</th>
                            <th style="line-height: 23px;">Status</th>
                            <th style="line-height: 23px;">Aangemaakt op</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="invoice in invoices" v-bind:key="invoice.id">
                            <td>{{ invoice.id }}</td>
                            <td>{{ invoice.reference }}</td>
                            <td>{{ invoice.totalFormatted }}</td>
                            <td>{{ invoice.payment_state }}</td>
                            <td>{{ invoice.createdAtFormatted }}</td>
                            <td class="text-right">
                                <a v-bind:href="route('employer.invoices.view', { invoice: invoice.id })" class="btn btn-primary">
                                    <i class="fas fa-eye"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            company_create_year: {
                type: Number,
                required: true,
            },
        },
        data: function () {
            return {
                invoices_list: [],
                invoices: [],
                selected_year: 0,
                current_year: 0,
                company_create: 0,
            }
        },
        // Can this be placed in a shared exported function?
        mounted: function () {
            this.selected_year = new Date().getFullYear().toString();
            this.current_year = new Date().getFullYear().toString();
            this.loadYear();
        },
        methods: {
            loadYear: function () {
                if (!this.invoices_list.hasOwnProperty(this.selected_year)) {
                    console.log('fetch');

                    let axios = require('axios');
                    axios.get(`/employer/invoices?year=${this.selected_year}`).then((response) => {
                        this.invoices_list[this.selected_year] = response.data.invoices;
                        this.invoices = this.invoices_list[this.selected_year];
                    });
                }

                this.invoices = this.invoices_list[this.selected_year];
            },
            nextYear: function () {
                this.selected_year++;
                this.loadYear();
            },
            previousYear: function () {
                this.selected_year--;
                this.loadYear();
            }
        }
    }
</script>
